import { ReactElement, useEffect } from "react";
import { navigateTo } from "client_legacy/ndaw/navigator";
import { CustomNotificationDataViewModel } from "client/Api/Notifications/notifications";

export type CustomActivityInvocationProps = {
	data: CustomNotificationDataViewModel;
	onDismiss: () => void;
};

export const CustomActivityInvocation = (props: CustomActivityInvocationProps): ReactElement | null => {
	const {
		data,
		onDismiss
	} = props;

	useEffect(
		() => {
			navigateTo(data.url, true);
			onDismiss();
		},
		[data.url, onDismiss]
	);

	return null;
};

CustomActivityInvocation.displayName = "CustomActivityInvocation";